import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=5c8ae0fa&"
import script from "./Authenticate.vue?vue&type=script&lang=js&"
export * from "./Authenticate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports